import { nonEmptyString } from "./nonEmptyString.js";

export const youtubeUrlSchema = nonEmptyString.url().refine((data) => {
	if (!URL.canParse(data)) {
		// Will report invalid URL
		return true;
	}

	const url = new URL(data);
	const hostname = url.hostname.replace(/^www\./u, "");

	return (
		(hostname === "youtu.be" && url.pathname.length > 2) ||
		(hostname === "youtube.com" && url.pathname === "/watch" && url.searchParams.has("v"))
	);
}, "URL YouTube videa musí začínat s https://youtu.be anebo https://youtube.com/watch?v=");
